
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("2fJ1u", function(module, exports) {
module.exports = new URL("icon-home.b876a652.svg", import.meta.url).toString();

});

parcelRegister("a1Pal", function(module, exports) {
module.exports = new URL("icon-resume.af9cac3c.svg", import.meta.url).toString();

});

parcelRegister("7qw7x", function(module, exports) {
module.exports = new URL("icon-project.452d86c8.svg", import.meta.url).toString();

});

parcelRegister("4QXI3", function(module, exports) {
module.exports = new URL("icon-faq.34741166.svg", import.meta.url).toString();

});

parcelRegister("l3Gza", function(module, exports) {
module.exports = new URL("icon-contact.2aab738b.svg", import.meta.url).toString();

});

var $cd20fbb9973fc4ed$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["inpbn","contact.4db2bcaa.js","fImjh","icon-home.b876a652.svg","cpNPS","icon-resume.af9cac3c.svg","6cCJm","icon-project.452d86c8.svg","gwpbK","icon-faq.34741166.svg","eOjbj","icon-contact.2aab738b.svg"]'));

// Wait for document to load before adding sidebar





document.addEventListener("DOMContentLoaded", ()=>{
    // Select the sidebar div
    const sidebar = document.querySelector("#sidebar");
    // Add the sidebar contents to the div
    sidebar.innerHTML = `
    <div id="btn">
          <div id="navMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <header>MASONS.CODES</header>
        <ul>
          <li>
            <a href="/"
              ><i></i
              ><img class="icon" src="${(parcelRequire("2fJ1u"))}" />Home</a
            >
          </li>
          <li>
            <a href="/resume"
              ><i></i
              ><img class="icon" src="${(parcelRequire("a1Pal"))}" />Resume</a
            >
          </li>
          <li>
            <a href="/projects"
              ><i></i
              ><img
                class="icon"
                src="${(parcelRequire("7qw7x"))}"
              />Projects</a
            >
          </li>
          <li>
            <a href="/faq"
              ><i></i><img class="icon" 
              src="${(parcelRequire("4QXI3"))}" />FAQ</a
            >
          </li>
          <li>
            <a href="/contact"
              ><i></i
              ><img class="icon" 
src="${(parcelRequire("l3Gza"))}" />Contact</a
            >
          </li>
        </ul>
  `;
    // Select the button and navMenu divs
    const btn = document.querySelector("#btn");
    const navMenu = document.querySelector("#navMenu");
    // Add listeners to toggle class on button click
    btn.addEventListener("click", ()=>{
        btn.classList.toggle("active");
        navMenu.classList.toggle("active");
        sidebar.classList.toggle("active");
    });
});


//# sourceMappingURL=contact.4db2bcaa.js.map
